<div class="publish-to-subscribers-container">
  <div class="employee-visibility-container">
    <app-publishing-visibility
      [isViewMode]="isViewMode"
      [employeeCount]="personCount"

      [visibilityMode]="visibilityMode"
      (visibilityModeChange)="onVisibilityModeChanged($event)"

      [organizationUnitIds]="selectedOrganizationUnitIds"
      (organizationUnitIdsChange)="onOrganizationUnitIdsChanged($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="onTrainingGroupIdsChanged($event)"

      [subscriptionIds]="subscriptionIds"
      (subscriptionIdsChange)="onSubscriptionIdsChanged($event)"

      [roleIds]="roleIds"
      (roleIdsChange)="onRoleIdsChanged($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [subscribers]="subscribers"
      [roles]="roles"
    ></app-publishing-visibility>
  </div>
  <hr>
  @if(visibilityMode === EventVisibilityMode.Subscribers) {
    <div class="standard-catalogue-container">
      <app-standard-catalogue-selector
        [isViewMode]="isViewMode"
        [standardTrainingCategories]="standardTrainingCategories"
        [standardTrainingCategoryIds]="standardTrainingCategoryIds"
        (standardTrainingCategoryIdsChange)="onStandardTrainingCategoryIdsChanged($event)"
        [usedStandardTrainingCategories]="usedStandardTrainingCategories"
      ></app-standard-catalogue-selector>
    </div>
  } @else {
    <div class="catalogue-container">
      <app-catalogue-selector
        [isViewMode]="isViewMode"
        [trainingCategories]="trainingCategories"
        [trainingCategoryIds]="trainingCategoryIds"
        (trainingCategoryIdsChange)="onTrainingCategoryIdsChanged($event)"
      ></app-catalogue-selector>
    </div>
  }
</div>